import Modal from "../../../../common/Modal";

import "./styles/index.css";

const ApiKeyConfirmationModal = ({ open, onOutsideClick, onDeleteClick, onCancelClick, apiKeyId, apiKeyName }) => {
  const onDeleteClickHandler = () => {
    onDeleteClick?.(apiKeyId);
  }

  const onCancelClickHandler = () => {
    onCancelClick?.();
  }

  if (!open) return null;

  return (
    <Modal
      open={open}
      setOpen={onOutsideClick}
      closeOnOutsideClick={true}
      className="api-key-info-modal"
    >
      <div
        className="confirm-modal-container"
        onClick={() => {}} // prevent closing modal on click inside
      >
        <h2>Are you sure you want to delete {apiKeyName} API Key?</h2>

        <div className="buttons-container">
          <button
            className="btn warning btn--small"
            onClick={onDeleteClickHandler}
          >
            {'Delete'}{' '}<span>{'API Key'}</span>
          </button>
          <button
            className="primary btn btn--small"
            onClick={onCancelClickHandler}
          >
            {'Cancel'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ApiKeyConfirmationModal;